import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { metadataIdFixer } from '@bibliocommons/utils-link';
import { bibJacketCoverAltText } from '@bibliocommons/utils-item';
import './SearchResultItem.scss';
import JacketCover from '@bibliocommons/shared-jacket-cover';
import { bibEventComposer } from '@bibliocommons/analytics-event-composers';
import { sendAnalyticsEvents } from '@bibliocommons/utils-analytics';
import { bindAll } from '@bibliocommons/utils-react';
import SearchResultItemContent from '../SearchResultItemContent';

const { composeImageClickEvent } = bibEventComposer;

// These props are used in SearchResultItemContent
/* eslint-disable react/no-unused-prop-types */
const propTypes = {
  availabilityDetail: ImmutablePropTypes.map,
  item: ImmutablePropTypes.map,
  itemRecommendations: ImmutablePropTypes.map,
  catalogSearchOptions: ImmutablePropTypes.map,
  branches: ImmutablePropTypes.list,
  currentUser: ImmutablePropTypes.map,
  showJacketCover: PropTypes.bool,
  showSeries: PropTypes.bool,
  order: PropTypes.number,
  reciprocalRank: PropTypes.number,
  dataKey: PropTypes.string,
  renderCards: PropTypes.func
};
/* eslint-enable react/no-unused-prop-types */

export class SearchResultItem extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  handleJacketClick() {
    const reciprocalRank = this.props.reciprocalRank;
    const metadataId = this.props.item.getIn(['briefInfo', 'metadataId']);

    sendAnalyticsEvents(
      composeImageClickEvent({
        containerName: 'bib-item',
        reciprocalRank,
        metadataId
      })
    );
  }

  render() {
    const { item, showJacketCover, showSeries, renderCards } = this.props;
    const jacketSource = item.getIn(['briefInfo', 'jacket']);
    const bibCoverAltText = bibJacketCoverAltText(
      item.getIn(['briefInfo', 'title']),
      item.getIn(['briefInfo', 'authors'])
    );

    const jacketBlock = (
      <div className="col-md-2 visible-md visible-lg item-column">
        <a
          href={`/item/show/${metadataIdFixer(item.get('id'))}`}
          onClick={this.handleJacketClick}
          tabIndex="-1"
          aria-hidden="true"
          target="_parent"
          data-key="bib-image-link"
        >
          <JacketCover
            src={jacketSource}
            format={item.getIn(['briefInfo', 'format'])}
            alt={bibCoverAltText}
            responsive
          />
        </a>
      </div>
    );

    const itemClass = showJacketCover ? 'col-md-10' : 'col-md-12';
    return (
      <li
        className="row cp-search-result-item"
        data-test-id="searchResultItem"
        style={{ order: this.props.order }}
        data-key={this.props.dataKey}
      >
        {showJacketCover ? jacketBlock : null}
        <div className={`${itemClass} item-column`}>
          <SearchResultItemContent
            {...this.props}
            showSeries={showSeries}
            id={item.get('id')}
            showJacketCover={showJacketCover}
          />
          {renderCards && renderCards()}
        </div>
      </li>
    );
  }
}

SearchResultItem.propTypes = propTypes;
SearchResultItem.defaultProps = {
  order: 0
};

export default SearchResultItem;
